// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".projects-gallery .grid-box{display:grid;grid-template-columns:repeat(3,minmax(0,1fr));grid-gap:20px}.projects-gallery .image-container{margin:0;cursor:pointer}.projects-gallery .img-box{padding-top:62%}.projects-gallery.altGallery .gradient{display:none}@media (max-width:1023px){.projects-gallery .grid-box{grid-template-columns:repeat(2,minmax(0,1fr))}}@media (max-width:767px){.projects-gallery .grid-box{grid-template-columns:repeat(1,minmax(0,1fr))}}", ""]);
// Exports
module.exports = exports;
